<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div class="publish-request-card mb-4">
    <form ref="publishRequestForm" method="POST">
      <input type="hidden" name="_token" :value="csrf_token">
      <input type="hidden" name="return_to_resource" value="1">
      <input type="hidden" name="rejection_reason" :value="rejectionReason">
    </form>

    <div class="publish-request-title">
      This resource has requested to be published in the following registries:
    </div>

    <div
      v-for="publishRequest in publishRequests"
      :key="publishRequest.id"
      class="publish-request-row"
    >
      <div class="publish-request-name">{{ publishRequest.irr.name }}</div>
      <div class="publish-request-actions">
        <button
          type="button"
          class="btn btn-registry btn-sm"
          @click="showApproveModal(publishRequest)"
        >
          Publish Resource
        </button>
        <button
          type="button"
          class="btn btn-danger btn-sm"
          @click="showDeclineModal(publishRequest)"
        >
          Decline Request
        </button>
      </div>
    </div>

    <div
      class="modal fade"
      id="resourceDeclinePublishModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="resourceDeclinePublishModalLabel"
      aria-hidden="true"
      style="z-index: 10001;"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="resourceDeclinePublishModalLabel">Decline Publication Request</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Please provide a reason for declining this resource publication request. This reason will be sent to the requestor via email.</p>
            <textarea
              v-model="rejectionReason"
              class="form-control"
              rows="5"
              placeholder="Enter decline reason here..."
              maxlength="1000"
            ></textarea>
            <small class="form-text text-muted mt-2">{{ rejectionReason.length }}/1000 characters</small>
            <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
            <button
              type="button"
              class="btn btn-registry"
              :disabled="!rejectionReason.trim()"
              @click="submitRequest(0)"
            >
              Decline Request
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="resourceApprovePublishModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="resourceApprovePublishModalLabel"
      aria-hidden="true"
      style="z-index: 10001;"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="resourceApprovePublishModalLabel">Approve Publication Request</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            By approving the publication of this resource in this registry, you agree to take responsibility for the content of this resource description. In particular, you represent that the description provided in this resource is accurate to the best of your knowledge and conforms to all applicable laws.
            <br>&nbsp;<br>
            <div class="checkbox">
              <label>
                <input v-model="approvalConfirmed" type="checkbox">
                &nbsp;<strong>I have read, understood and agreed to the above.</strong>
              </label>
            </div>
            <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
            <button
              type="button"
              class="btn btn-registry"
              :disabled="!approvalConfirmed"
              @click="submitRequest(1)"
            >
              Approve
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      props: {
        publishRequests: {
          type: Array,
          required: true,
        },
        csrf_token: String,
      },
      data: function () {
        return {
          selectedRequest: null,
          rejectionReason: '',
          approvalConfirmed: false,
        }
      },
      methods: {
        showApproveModal: function (publishRequest) {
          this.selectedRequest = publishRequest;
          this.approvalConfirmed = false;
          $('#resourceApprovePublishModal').modal('show');
        },
        showDeclineModal: function (publishRequest) {
          this.selectedRequest = publishRequest;
          this.rejectionReason = '';
          $('#resourceDeclinePublishModal').modal('show');
        },
        submitRequest: function (approve) {
          if (!this.selectedRequest) {
            return;
          }
          if (approve && !this.approvalConfirmed) {
            return;
          }
          if (!approve && !this.rejectionReason.trim()) {
            return;
          }

          const form = this.$refs.publishRequestForm;
          form.action = '/irr/' + this.selectedRequest.irr.id
            + '/publishrequests/' + this.selectedRequest.id + '/' + approve;
          $('.modal').modal('hide');
          form.submit();
        },
      },
    }
</script>

<style scoped>
  .publish-request-card {
    background: #ffffff;
    border: 4px solid #d14413;
    border-radius: 30px;
    padding: 1.5rem 2rem;
  }

  .publish-request-heading {
    font-size: 1.35rem;
    margin-bottom: 1.25rem;
  }

  .publish-request-row {
    align-items: center;
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    margin-bottom: 0.75rem;
  }

  .publish-request-row:last-of-type {
    margin-bottom: 0;
  }

  .publish-request-title {
    font-size: 1.2rem;
    font-weight: 600;
  }

  .publish-request-name {
    font-size: 1.2rem;
    font-weight: 500;
  }

  .publish-request-actions {
    display: flex;
    flex-shrink: 0;
    gap: 0.75rem;
  }

  @media (max-width: 767px) {
    .publish-request-card {
      padding: 1.25rem;
    }

    .publish-request-row {
      align-items: flex-start;
      flex-direction: column;
    }

    .publish-request-actions {
      flex-wrap: wrap;
    }
  }
</style>
